import { OptionGroup } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { useWorkflowContext } from '../../state/WorkflowContext';

export const FlowSchemesPreviewToggle = () => {
  const { t } = useTranslation('global');
  const { workflowView, setWorkflowView } = useWorkflowContext();
  return (
    <OptionGroup
      options={[
        { value: 'condensed', label: t('approvalWorkflows.toggle.condensed') },
        { value: 'extended', label: t('approvalWorkflows.toggle.extended') },
      ]}
      name="flowSchemesPreview"
      value={workflowView}
      onChange={(event) => {
        setWorkflowView(
          event.target.value === 'extended' ? 'extended' : 'condensed',
        );
      }}
    />
  );
};
